import ReactGA from "react-ga4";

const ENV = process.env.REACT_APP_ENV;

export const trackEvent = (eventName: string, params = {}) => {
  if (ENV !== "production") return;

  ReactGA.event(eventName, params);
};
